<template>
  <div>
    <HeaderVue></HeaderVue>
    <AgentMenuTab v-if="isLoggedIn" />
    <router-view></router-view>
    <FooterView></FooterView>
  </div>
</template>
<style>
@import url('@/assets/Agent/css/style.css');
</style>

<script>
    import FooterView from './Footer.vue';
    import HeaderVue from '../common/Header.vue';
    import AgentMenuTab from './AgentMenuTab.vue';
    import { agentStore } from '../store';
    export default{
        name:'layout-agent',
        components:{
            HeaderVue,
            FooterView,
            AgentMenuTab,
        },
        computed: {
            isLoggedIn() {
                return agentStore().isLoggedIn;
            }
        }
        ,
        mounted() {
            // start session monitor if user already logged in and attach activity listeners
            this.auth = agentStore();
            if (this.auth.isLoggedIn) {
                this.auth.startSessionMonitor();
            }
            // activity events to keep session alive
            this._activityHandler = () => {
                try {
                    this.auth.touchActivity();
                } catch (e) {
                    console.error('Error occurred while touching activity:', e);
                }
            };
            ['mousemove', 'keydown', 'click', 'touchstart'].forEach(evt => {
                window.addEventListener(evt, this._activityHandler);
            });
        },
        beforeUnmount() {
            ['mousemove', 'keydown', 'click', 'touchstart'].forEach(evt => {
                window.removeEventListener(evt, this._activityHandler);
            });
        }
    }
</script>
